import React, { useState } from "react";
import { Link, Outlet } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";

import logo from "../images/logo.png";
import "./styles/Nav.css";
import TogglerButton from "./TogglerButton/TogglerButton";
import Menu from "./Menu/Menu";
import MenuModal from "./MenuModal/MenuModal";
import { logout } from "../redux/reducers/user";
import { removeState } from "../utils/useLocalStorage";

export const Nav = () => {
  const user = useSelector((state) => state.user.value);
  const dispatch = useDispatch();

  const [isActive, setIsActive] = useState(false);

  const handleToggle = () => {
    setIsActive(!isActive);
  };

  const closeModal = () => {
    setIsActive(false);
  };

  return (
    <div>
      <header className="main-header-two clearfix">
        <div className="main-header-two__top clearfix">
          <div className="container clearfix">
            <div className="main-header-two__top-inner clearfix">
              <div className="main-header-two__top-left">
                <div className="main-header-two__logo">
                  <Link to="/">
                    <img src={logo} alt="atease logo" />
                  </Link>
                </div>
              </div>
              <div className="main-header-two__top-right">
                <div className="main-header-two__top__motto">
                  <div className="main-header-two__top-motto-text ">
                    <h2>SAFE HAVEN FOR FREELANCERS AND STARTUPS</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <nav className="main-menu main-menu-two clearfix">
          <div className="main-menu-two-wrapper clearfix">
            <div className="container clearfix">
              <div className="main-menu-two-wrapper__inner clearfix">
                <div className="main-menu-two-wrapper__left">
                  <div className="main-menu-two-wrapper__main-menu">
                    {/* TOGGLER BUTTON */}
                    <div className="mobile-nav__toggler">
                      <div
                        className=""
                        onClick={handleToggle}
                      >
                        <TogglerButton isActive={isActive} />
                      </div>
                    </div>

                    {/* MENU MODAL */}
                    <MenuModal isActive={isActive} closeModal={closeModal}>
                      <Menu setIsActive={setIsActive} />
                    </MenuModal>

                    <ul className="main-menu__list">
                      <li>
                        <Link to="/">HOME</Link>
                      </li>
                      <li>
                        <Link to="/services">SERVICES</Link>
                      </li>
                      {user && (
                        <li>
                          <Link to="/dashboard">DASHBOARD</Link>
                        </li>
                      )}
                      <li>
                        <Link to="/about">ABOUT US</Link>
                      </li>
                      <li>
                        <Link to="/contact">CONTACT US</Link>
                      </li>
                      <li>
                        <a
                          href="https://dev-ateaseinsurance.pantheonsite.io"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          OUR BLOG
                        </a>
                      </li>
                      {!user && (
                        <li>
                          <Link to="/register">REGISTER</Link>
                        </li>
                      )}
                      {!user && (
                        <li>
                          <span className="sign-up-in">
                            <Link to="/login">LOGIN</Link>
                          </span>
                        </li>
                      )}
                      {user && (
                        <li>
                          <span className="sign-up-in">
                            <Link
                              to="/login"
                              onClick={() => {
                                dispatch(logout(user));
                                removeState("user");
                              }}
                            >
                              LOGOUT
                            </Link>
                          </span>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
                <div className="main-menu-two-wrapper__right">
                  <div className="main-menu-two-wrapper__search-box">
                    <FaSearch />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <Outlet />
      </header>
    </div>
  );
};

export default Nav;
